import { ILoadPublishTermsFail } from './types';

export const DEFAULT_RESULT: ILoadPublishTermsFail = {
  success: false,
  payload: 'Получение услуг завершилось с ошибкой',
};
